import React, {Component, Fragment, useState} from 'react'
import {Carousel} from "react-responsive-carousel";
import {ASSET_URL} from "../../../config";
import {ConfigProvider, Modal} from "antd";
import {getLayoutDirection} from "../../../locales";

export default function Hero({context,campagneData,campagneTarget,noVideo}){

    const [visibleVideo,setVisibleVideo]=useState(false)

    const images=campagneData.config["banners"] || []
    const mobileImages=images.filter(i=>i.type==="MOBILE") || []
    const desktopImages=images.filter(i=>i.type==="DESKTOP") || []

    let finalImages=desktopImages
    if(context.isMobile && mobileImages.length>0){
        finalImages=mobileImages
    }

    return(
        <Fragment>
            <div dir={"ltr"} style={{position:"relative"}}>
                <Carousel
                    autoPlay
                    showStatus={false}
                    showThumbs={false}
                    showIndicators={false}
                    showArrows={!campagneData.config["banners.youtube"] && !noVideo}
                    autoFocus
                    interval={5000}
                    infiniteLoop
                    swipeable
                    width={"100%"}
                    emulateTouch={true}
                >
                {finalImages.map(i=>{
                        let ratio="3.84/1"
                        if(context.isMobile){
                            ratio="1.46/1"
                        }
                        return(
                            <div className={"carousel-hero"} style={{
                                backgroundRepeat:"no-repeat",
                                backgroundPosition:"center",
                                backgroundSize:"cover",
                                backgroundImage:"url("+ASSET_URL+i.image+")",
                                width:"100%",
                                aspectRatio:ratio
                            }}/>
                        )
                    })}

                </Carousel>
                {campagneData.config["banners.youtube"] && !noVideo ? (
                    <div onClick={()=>setVisibleVideo(true)} style={{cursor:"pointer",position:"absolute",zIndex:100,top:0,left:0,right:0,bottom:0,display:"flex",justifyContent:"center",alignItems:"center"}}>
                        <i className={"fa fa-play-circle"} style={{color:"#FFF",fontSize:60,filter:"drop-shadow(3px 3px 10px rgba(0,0,0,0.3))",}}></i>
                    </div>
                ):null}
            </div>

            {campagneData.config["banners.youtube"] && !noVideo ? (
                <ConfigProvider
                    direction={getLayoutDirection(context.langValue)}
                    theme={{
                        components: {
                            Modal: {
                                contentBg:"transparent",
                            },
                        },
                        token: {
                            colorIcon:"#FFF",
                            colorIconHover:"#FFF",
                            borderRadiusLG:0,
                            borderRadiusSM:0,
                        }
                    }}
                >
                <Modal centered footer={false} open={visibleVideo} width={context.isMobile?"100%":850} onCancel={()=>setVisibleVideo(false)} destroyOnClose>
                    <div style={{marginTop:30}}>
                        <iframe
                            src={"https://www.youtube.com/embed/" + campagneData.config["banners.youtube"] + "?&rel=0&autoplay="+(visibleVideo?"1":"0")+"&playsinline=1&iv_load_policy=3&modestbranding=1&enablejsapi=1&widgetid=1&mute=0&loop=1"}
                            style={{height: context.isMobile?300:400, width: context.isMobile?"100%":800}}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen/>
                    </div>
                </Modal>
                </ConfigProvider>
            ) : null}
        </Fragment>
    )
}

//https://www.youtube.com/embed/XVN91Ycg9XU?autoplay=0&mute=0&controls=0&origin=http%3A%2F%2Flocalhost%3A4000&playsinline=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&enablejsapi=1&widgetid=1